// SimpleTabs.js
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import CustomTab from "./TabComponent";
import CustomTabPanel from "./TabPanelComponent";
import { a11yProps } from "./Utils";
import AddSingle from "./AddSingle";

import QuestionList from "./QuestionList";
import ImportFromQuestionBank from "./ImportFromQuestionBank";
import EditSingle from "./EditSingleone";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import {
  Typography,
  Button,
  Modal,
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { useNavigate, useParams } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "1rem",
    flexGrow: 1,
    "& .MuiAppBar-colorPrimary": {
      color: "#fff",
      backgroundColor: "#484848",
    },
    "& .MuiTab-textColorInherit.Mui-selected": {
      color: "#252525",
      backgroundColor: "#FFFFFF",
    },
  },
  tab: {
    margin: "0.5rem",
    padding: "0.7rem",
    minHeight: "auto",
    borderRadius: "6px",
    opacity: 1,
    "&:hover": {
      color: "#252525",
      backgroundColor: "#FFFFFF",
    },
  },
  tabpannel: {},
  deletebtn: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  custombtnblue: {
    background: "#00577B !important",
    color: "white !important",
    fontSize: "1rem !important",
    fontFamily: "Outfit !important",
    fontWeight: "600 !important",
    textTransform: "capitalize !important",
    padding: "0.4rem 2rem !important",
    margin: "10px",
    "&:hover": {
      background: "#00577B !important",
      color: "white !important",
    },
  },
}));

const modalStyle2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 410,
  backgroundColor: "white",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  borderRadius: "8px",
};

export default function SimpleTabs({
  questionsCount,
  examDetails,
  examTemplate,
  setLoading,
}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [editQuestion, setEditQuestion] = useState();
  const [questionsLength, setQuestionsLength] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [IsDelete, setIsDelete] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleToggleShowPassword = () => setShowPassword(!showPassword);

  const { rowId } = useParams();
  const navigate = useNavigate();

  const handleSyncQpClick = () => {
    const encryptedEmail = sessionStorage.getItem("email");
    const decryptedEmail = decryptData(encryptedEmail) || "";
    const userEmail = decryptedEmail.toString().toLowerCase();

    if (userEmail.includes("unacademy@gmail.com")) {
      navigate(`/admin/unacademy-qpsync/${rowId}`);
    } else {
      navigate(`/admin/qpsync/${rowId}`);
    }
  };

  const buttonContainerStyle = {
    marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/bulk/question/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      toast.success("All questions deleted successfully");
      setOpenDelete(false);
      window.location.reload();
    } catch (error) {
      toast.error("Questions is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = async () => {
    if (!password) {
      toast.error("Please enter a password.");
      return;
    }

    try {
      const checkPasswordData = { user: { password } };

      const passwordCheckResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/check/password`,
        checkPasswordData,
        { headers: { Authorization: `Bearer ${decryptedToken}` } }
      );

      if (!passwordCheckResponse.data.success) {
        toast.error("Invalid password. Please try again.");
        return;
      }
      handleDelete();
    } catch (error) {
      console.error("Error changing learner status:", error);
      toast.error("Invalid password. Please try again.");
    }
  };

  // Function to change tab
  const changeTab = (tabIndex) => {
    setValue(tabIndex);
  };

  // Function to change tab
  const EditchangeTab = (tabIndex, value) => {
    setValue(tabIndex);
    setEditQuestion(value);
  };

  const items = [
    { id: 1, label: "Questions List" },
    { id: 2, label: "Add Single Question" },
    // { id: 4, label: "Delete All QP" },
    // { id: 3, label: "IMPORT FROM QUESTION BANK" },
  ];
  /*
   */
  const items1 = [
    {
      id: 1,
      label: (
        <QuestionList
          changeTab={EditchangeTab}
          setQuestionsLength={setQuestionsLength}
          setLoading={setLoading}
        />
      ),
    },
    { id: 2, label: <AddSingle /> },
    {
      id: 3,
      label: (
        <EditSingle
          questionId={editQuestion?.questionId}
          examId={editQuestion?.examId}
          fetchData={editQuestion?.fetchData}
          rowId={editQuestion?.rowId}
          examDetails={examDetails}
          examTemplate={examTemplate}
          changeTab={changeTab}
        />
      ),
    },
  ];

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="none"
          aria-label="simple tabs example"
        >
          {items.map((item) => (
            <CustomTab
              className={classes.tab}
              key={item.id}
              label={item.label}
              id={item.id}
              index={item.id - 1}
              onChange={handleChange}
              {...a11yProps(item.id)}
            />
          ))}
          <div className={`${classes.deletebtn}`}>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleSyncQpClick}
              style={{ marginRight: "10px", background: "#007B55 !important" }}
            >
              Sync QP
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={() => setOpenDelete(true)}
              type=""
            >
              Delete all QP
            </Button>
          </div>
        </Tabs>
      </AppBar>

      {items1.map((item, index) => (
        <CustomTabPanel key={item.id} value={value} index={index} id={item.id}>
          {index === 1 ? (
            <AddSingle
              changeTab={changeTab}
              examDetails={examDetails}
              examTemplate={examTemplate}
              questionsLength={questionsLength}
            />
          ) : (
            item.label
          )}
        </CustomTabPanel>
      ))}

      <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
        {IsDelete ? (
          <div style={modalStyle2}>
            <Typography
              variant="h6"
              style={{ marginBottom: "20px", textAlign: "center" }}
            >
              Enter Your Password
            </Typography>
            <TextField
              fullWidth
              type={showPassword ? "text" : "password"}
              variant="outlined"
              required
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleToggleShowPassword} edge="end">
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />{" "}
            <div style={buttonContainerStyle}>
              <Button
                onClick={() => {
                  setOpenDelete(false);
                  setIsDelete(false);
                }}
                variant="outlined"
                style={{ marginRight: "10px" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleStatus}
                variant="contained"
                color="primary"
              >
                submit
              </Button>
            </div>
          </div>
        ) : (
          <div style={modalStyle2}>
            <Typography
              variant="h6"
              style={{ marginBottom: "20px", textAlign: "center" }}
            >
              Are you confirm to delete all questions ?
            </Typography>

            <div style={buttonContainerStyle}>
              <Button
                onClick={() => setOpenDelete(false)}
                variant="outlined"
                style={{ marginRight: "10px" }}
              >
                No
              </Button>
              <Button
                onClick={() => setIsDelete(true)}
                variant="contained"
                color="primary"
              >
                Yes
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
